import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../../../../hooks/auth/useAuth';
import CertificateTasksTab from './tabs/certificate-tasks-tab/CertificateTasksTab';
import ComponentTasksTab from './tabs/component-tasks-tab/ComponentTasksTab';
import ProductTasksTab from './tabs/product-tasks-tab/ProductTasksTab';
import styles from './TasksTabView.module.css';

const BASE_TABS = ['product-tasks', 'component-tasks'];

const TasksTabView = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const isCertificateManagementEnabled = user?.company?.isCertificateManagementEnabled === true;

  const tabs = useMemo(() => {
    if (isCertificateManagementEnabled) {
      return [...BASE_TABS, 'certificate-tasks'];
    }

    return BASE_TABS;
  }, [isCertificateManagementEnabled]);

  const activeTabIndex = useMemo(() => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const activeTab = pathSegments[pathSegments.length - 1];

    return Math.max(tabs.indexOf(activeTab), 0);
  }, [location.pathname, tabs]);

  const handleTabChange = (event: TabViewTabChangeEvent) => {
    navigate(`/tasks/${tabs[event.index]}`);
  };

  return (
    <TabView
      className={styles['tasks-tab-view']}
      pt={{
        nav: { className: 'flex flex-row gap-6' },
      }}
      activeIndex={activeTabIndex}
      onTabChange={handleTabChange}
    >
      <TabPanel header={t('tasksPage.tabs.productTasksTab.tabHeader')}>
        <ProductTasksTab />
      </TabPanel>

      <TabPanel header={t('tasksPage.tabs.componentTasksTab.tabHeader')}>
        <ComponentTasksTab />
      </TabPanel>

      {isCertificateManagementEnabled && (
        <TabPanel header={t('tasksPage.tabs.certificateTasksTab.tabHeader')}>
          <CertificateTasksTab />
        </TabPanel>
      )}
    </TabView>
  );
};

export default TasksTabView;
